import { isEmpty } from 'ramda'

export const shouldWidgetIconDisplay = (state) => {
  const { view = {}, conversations = {}, embed = {}, campaigns = {} } = state

  const hasMatchedTargeting = view.matchedTargeting // has matched widget display targeting
  const hasForcedConversation = conversations.hasForcedConversation // has had a forced conversation (i.e. driftlink/live view msg)
  const hasActiveCampaign = !!campaigns?.activeCampaign?.id
  const hasHadConversations = !isEmpty(conversations.conversations)
  const hasShowIconIfHasHadConversationsGate = !!embed?.configuration?.gates['show_chat_existing_conversations']

  if (hasShowIconIfHasHadConversationsGate && hasHadConversations) {
    return true
  }

  return hasMatchedTargeting || hasForcedConversation || hasActiveCampaign
}

export const isChatOpen = (state) => {
  const { view = {} } = state
  return view.chatOpen
}
